import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a36d10b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=5a36d10b&prod&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=5a36d10b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a36d10b",
  null
  
)

export default component.exports